module.exports = __webpack_public_path__ + "img/truck_05.a481eece.jpg";